import { SvgIcon, SxProps, Theme, useTheme } from "@mui/material";
import { ReactElement } from "react";

export default function EmptyParameterListSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    const {
        palette: {
            primary: { main },
        },
    } = useTheme();
    return (
        <SvgIcon
            viewBox="0 0 237 205"
            sx={{ width: 237, height: 205, fill: "none", ...sx }}
        >
            <path
                d="M102 204C158.333 204 204 158.333 204 102C204 45.667 158.333 0 102 0C45.667 0 0 45.667 0 102C0 158.333 45.667 204 102 204Z"
                fill="url(#paint0_linear_2917_17781)"
                fillOpacity="0.5"
            />
            <g filter="url(#filter0_d_2917_17781)">
                <rect
                    x="20.5078"
                    y="49.3564"
                    width="145.167"
                    height="47.2215"
                    rx="6"
                    fill="white"
                />
            </g>
            <rect
                x="65.8896"
                y="62.3418"
                width="65.4653"
                height="4.03961"
                rx="2.0198"
                fill="#BDC0C7"
            />
            <rect
                x="65.8896"
                y="70.5654"
                width="47.2345"
                height="4.03961"
                rx="2.0198"
                fill="#BEC3C9"
            />
            <rect
                x="65.8896"
                y="78.8689"
                width="18.2309"
                height="4.03961"
                rx="2.0198"
                fill="#DCDDE1"
            />
            <path
                d="M43.8082 58.4456C40.9897 58.4456 38.2345 59.2748 35.891 60.8283C33.5475 62.3819 31.721 64.5901 30.6424 67.1736C29.5638 69.7571 29.2816 72.5999 29.8314 75.3425C30.3813 78.0851 31.7385 80.6044 33.7315 82.5817C35.7245 84.559 38.2637 85.9056 41.0281 86.4511C43.7924 86.9967 46.6577 86.7167 49.2617 85.6465C51.8657 84.5764 54.0913 82.7642 55.6572 80.4392C57.2231 78.1141 58.0588 75.3805 58.0588 72.5842C58.0588 68.8344 56.5574 65.2382 53.8849 62.5867C51.2124 59.9352 47.5877 58.4456 43.8082 58.4456ZM45.5896 82.7463H42.0269V79.2116H45.5896V82.7463ZM46.5426 74.6078C46.2398 74.7785 45.9906 75.029 45.8224 75.3316C45.6542 75.6341 45.5736 75.9769 45.5896 76.3221V76.5607H42.0269V76.3221C42.013 75.3158 42.2818 74.3256 42.8033 73.4625C43.3248 72.5994 44.0784 71.8974 44.9795 71.4354C45.43 71.2174 45.8096 70.8781 46.075 70.4562C46.3404 70.0343 46.4808 69.5468 46.4802 69.0495C46.4622 68.3521 46.1749 67.6881 45.6776 67.1948C45.1804 66.7015 44.5112 66.4164 43.8082 66.3985C43.0996 66.3985 42.4199 66.6778 41.9189 67.175C41.4178 67.6721 41.1362 68.3464 41.1362 69.0495H37.5736C37.5736 67.409 38.2305 65.8356 39.3997 64.6756C40.5689 63.5156 42.1547 62.8639 43.8082 62.8639C45.455 62.8856 47.0281 63.5443 48.1926 64.6996C49.3571 65.855 50.021 67.4157 50.0429 69.0495C50.0475 70.2093 49.7212 71.3466 49.1018 72.3302C48.4824 73.3137 47.5952 74.1033 46.5426 74.6078Z"
                fill="url(#paint1_linear_2917_17781)"
            />
            <g filter="url(#filter1_d_2917_17781)">
                <rect
                    x="53.9854"
                    y="91.772"
                    width="163.015"
                    height="47.2215"
                    rx="6"
                    fill="white"
                />
            </g>
            <rect
                x="100.81"
                y="103.89"
                width="79.3963"
                height="4.03961"
                rx="2.0198"
                fill="#BDC0C7"
            />
            <rect
                x="100.81"
                y="112.979"
                width="61.0741"
                height="4.03959"
                rx="2.0198"
                fill="#BEC3C9"
            />
            <rect
                x="100.81"
                y="123.078"
                width="25.4475"
                height="4.03961"
                rx="2.0198"
                fill="#DCDDE1"
            />
            <path
                d="M77.3961 100.861C74.5776 100.861 71.8224 101.691 69.4789 103.244C67.1354 104.798 65.3089 107.006 64.2303 109.589C63.1517 112.173 62.8695 115.016 63.4193 117.758C63.9692 120.501 65.3264 123.02 67.3194 124.997C69.3124 126.975 71.8516 128.321 74.616 128.867C77.3803 129.412 80.2456 129.132 82.8496 128.062C85.4536 126.992 87.6792 125.18 89.2451 122.855C90.8109 120.53 91.6467 117.796 91.6467 115C91.6467 111.25 90.1453 107.654 87.4728 105.002C84.8003 102.351 81.1756 100.861 77.3961 100.861ZM79.1775 125.162H75.6148V121.627H79.1775V125.162ZM80.1305 117.024C79.8277 117.194 79.5785 117.445 79.4103 117.747C79.2421 118.05 79.1615 118.393 79.1775 118.738V118.976H75.6148V118.738C75.6009 117.732 75.8697 116.741 76.3912 115.878C76.9127 115.015 77.6663 114.313 78.5673 113.851C79.0179 113.633 79.3975 113.294 79.6629 112.872C79.9283 112.45 80.0687 111.963 80.0681 111.465C80.0501 110.768 79.7628 110.104 79.2655 109.611C78.7683 109.117 78.0991 108.832 77.3961 108.814C76.6875 108.814 76.0078 109.094 75.5067 109.591C75.0056 110.088 74.7241 110.762 74.7241 111.465H71.1615C71.1615 109.825 71.8183 108.251 72.9876 107.091C74.1568 105.931 75.7426 105.28 77.3961 105.28C79.0428 105.301 80.6159 105.96 81.7805 107.115C82.945 108.271 83.6089 109.832 83.6308 111.465C83.6353 112.625 83.3091 113.762 82.6897 114.746C82.0703 115.73 81.183 116.519 80.1305 117.024Z"
                fill="url(#paint2_linear_2917_17781)"
            />
            <g filter="url(#filter2_d_2917_17781)">
                <rect
                    x="20.5059"
                    y="133.109"
                    width="145.167"
                    height="47.2215"
                    rx="6"
                    fill="white"
                />
            </g>
            <rect
                x="65.7217"
                y="146.096"
                width="65.4653"
                height="4.03961"
                rx="2.0198"
                fill="#BDC0C7"
            />
            <rect
                x="65.7217"
                y="154.317"
                width="47.2345"
                height="4.03961"
                rx="2.0198"
                fill="#BEC3C9"
            />
            <rect
                x="65.7217"
                y="162.624"
                width="18.2308"
                height="4.03961"
                rx="2.0198"
                fill="#DCDDE1"
            />
            <path
                d="M43.8063 142.267C40.9878 142.267 38.2326 143.097 35.8891 144.65C33.5456 146.204 31.719 148.412 30.6404 150.995C29.5618 153.579 29.2796 156.422 29.8295 159.164C30.3794 161.907 31.7366 164.426 33.7296 166.403C35.7226 168.381 38.2618 169.727 41.0261 170.273C43.7905 170.818 46.6558 170.538 49.2598 169.468C51.8637 168.398 54.0894 166.586 55.6552 164.261C57.2211 161.936 58.0569 159.202 58.0569 156.406C58.0569 152.656 56.5555 149.06 53.883 146.408C51.2105 143.757 47.5858 142.267 43.8063 142.267ZM45.5876 166.568H42.025V163.033H45.5876V166.568ZM46.5406 158.43C46.2379 158.6 45.9886 158.851 45.8204 159.153C45.6522 159.456 45.5717 159.799 45.5876 160.144V160.382H42.025V160.144C42.011 159.138 42.2799 158.147 42.8014 157.284C43.3229 156.421 44.0764 155.719 44.9775 155.257C45.428 155.039 45.8077 154.7 46.0731 154.278C46.3384 153.856 46.4789 153.369 46.4783 152.871C46.4602 152.174 46.1729 151.51 45.6757 151.017C45.1785 150.523 44.5093 150.238 43.8063 150.22C43.0976 150.22 42.418 150.5 41.9169 150.997C41.4158 151.494 41.1343 152.168 41.1343 152.871H37.5716C37.5716 151.231 38.2285 149.657 39.3977 148.497C40.5669 147.337 42.1528 146.686 43.8063 146.686C45.453 146.707 47.0261 147.366 48.1906 148.521C49.3551 149.677 50.019 151.238 50.0409 152.871C50.0455 154.031 49.7193 155.168 49.0999 156.152C48.4805 157.136 47.5932 157.925 46.5406 158.43Z"
                fill="url(#paint3_linear_2917_17781)"
            />
            <defs>
                <filter
                    id="filter0_d_2917_17781"
                    x="0.507812"
                    y="33.3564"
                    width="185.167"
                    height="87.2214"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.101961 0 0 0 0 0.384314 0 0 0 0 0.94902 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2917_17781"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2917_17781"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_2917_17781"
                    x="33.9854"
                    y="75.772"
                    width="203.015"
                    height="87.2214"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2917_17781"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2917_17781"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_d_2917_17781"
                    x="0.505859"
                    y="117.109"
                    width="185.167"
                    height="87.2214"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.101961 0 0 0 0 0.384314 0 0 0 0 0.94902 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2917_17781"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2917_17781"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2917_17781"
                    x1="102"
                    y1="-2.99487e-08"
                    x2="101.498"
                    y2="148.227"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={main} stopOpacity="0.5" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2917_17781"
                    x1="43.8082"
                    y1="58.4456"
                    x2="43.8082"
                    y2="86.7228"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={main} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2917_17781"
                    x1="77.3961"
                    y1="100.861"
                    x2="77.3961"
                    y2="129.139"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={main} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2917_17781"
                    x1="43.8063"
                    y1="142.267"
                    x2="43.8063"
                    y2="170.545"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={main} />
                    <stop offset="1" stopColor="#9BBCFF" />
                </linearGradient>
            </defs>
        </SvgIcon>
    );
}
